import { contractServiceClient } from '@lib/documentServiceClient';
import { createPlaceholderCatalogService } from '@workpay/ds-shared/services/placeholderCatalogService';

export const dsPlaceholderCatalogService = createPlaceholderCatalogService(contractServiceClient);
